import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "@phosphor-icons/react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart, toggleWishlist, isInWishlist } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();
  const inWishlist = isInWishlist(product.id);

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user || user === false) { navigate("/auth"); return; }
    if (product.coming_soon) return;
    await addToCart(product.id);
  };

  const handleToggleWishlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user || user === false) { navigate("/auth"); return; }
    await toggleWishlist(product.id);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block luxury-card border border-[rgba(212,175,55,0.1)] bg-[#121212] animate-fade-in-up"
      style={{ animationDelay: `${index * 100}ms`, opacity: 0 }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[#0a0a0a]">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover product-image-hover"
          loading="lazy"
        />
        {/* Overlay actions */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-500 flex items-end justify-center pb-6 opacity-0 group-hover:opacity-100">
          {!product.coming_soon && (
            <button
              onClick={handleAddToCart}
              className="bg-[#D4AF37] text-black px-6 py-2.5 text-xs tracking-[0.15em] uppercase font-medium hover:bg-[#E5C158] transition-all duration-300 transform translate-y-4 group-hover:translate-y-0"
              data-testid={`add-to-cart-${product.id}`}
            >
              Add to Bag
            </button>
          )}
        </div>
        {/* Wishlist button */}
        <button
          onClick={handleToggleWishlist}
          className={`absolute top-4 right-4 w-9 h-9 flex items-center justify-center transition-all duration-300 ${
            inWishlist ? "text-[#D4AF37]" : "text-white/50 hover:text-[#D4AF37]"
          }`}
          data-testid={`wishlist-toggle-${product.id}`}
        >
          <Heart size={20} weight={inWishlist ? "fill" : "thin"} />
        </button>
        {/* Coming soon badge */}
        {product.coming_soon && (
          <div className="absolute top-4 left-4 border border-[#D4AF37] text-[#D4AF37] px-3 py-1 text-[10px] uppercase tracking-[0.2em]">
            Coming Soon
          </div>
        )}
        {product.featured && !product.coming_soon && (
          <div className="absolute top-4 left-4 bg-[#D4AF37] text-black px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-medium">
            Featured
          </div>
        )}
      </div>
      <div className="p-5">
        <p className="text-xs text-[#A1A1AA] uppercase tracking-[0.15em] mb-2 font-light">
          {product.category?.replace("-", " ")}
        </p>
        <h3 className="font-['Cormorant_Garamond'] text-xl font-light text-[#FDFBF7] mb-2 group-hover:text-[#D4AF37] transition-colors duration-300">
          {product.name}
        </h3>
        {!product.coming_soon && (
          <p className="text-[#D4AF37] text-sm font-light">${product.price?.toFixed(2)}</p>
        )}
      </div>
    </Link>
  );
}
